import React from 'react'
import {
  CircularProgress,
  Typography,
  Grid,
  Box
} from '@mui/material'


interface LoadingProps {
  message?: string | undefined
  color?: string
  size?: number
}

export default function Loading({
  message,
  color,
  size,
}: LoadingProps) {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box color={color ? color : 'primary'}>
        <CircularProgress
          color={color ? 'inherit' : 'primary'}
          size={size || 70}
        />
      </Box>

      <Box color={color ? color : 'inherit'}>
        <Typography color="inherit">{message}</Typography>
      </Box>
    </Grid>
  );
}
